import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { store } from './index';

export interface stageType {
	[key: string]: boolean;
}
export interface sortType {
	type: string,
	reverse?: boolean
}
export interface trackerItemState {
	id: string,
	message: string,
	weight: number,
	value: string,
	stage: string,
	isVisible?: boolean,
}
export interface caseListState {
	caseno: string,
	description: string,
	team: string,
	handler: string,
	address: string,
	siteid: string,
	site: string,
	opened: string,
	type: string,
	casetype: string,
	progress: number,
	visible: boolean,
	selected: boolean,
	wishlisted: string,
	tracker: trackerItemState[],
	stage: stageType,
	linked: caseListState[],
	unviewActions: string[],
}
export interface siteListState {
	siteid: string | null,
	site: string
}
export interface schemeListState {
	schemeid: string,
	scheme: string,
	introducerid: string,
	introducer: string,
	developerid: string,
	developer: string,
	sites: siteListState[]
}
interface getCasesState {
	user: string,
	security: string
}
interface updateCaseActionState {
	id: string,
	readDate: string
}
interface getCaseState {
	caseno: string,
	type: string,
	id: string,
	token: string
}
export interface wishlistCaseState {
	caseno: string,
	id: string,
	usertype: string,
	token: string,
	casetype: string,
	type: string,
	month: number
}
export interface removeWishlistState {
	caseno: string,
	id: string,
	token: string,
}
export interface updateCaseDatesState {
	caseno: string,
	id: string,
	usertype: string,
	token: string,
	casetype: string,
	handler: string,
	valuation_booked: string,
	mortgage_completed: string,
	valuation_completed: string
}
export interface updatedTrackerChartDataState {
	casekey: string,
	caseType: string,
	chartData: string
}
export interface chaseCaseState {
	caseno: string,
	id: string,
	usertype: string,
	token: string,
	casetype: string,
	handler: string,
	type: string,
	reason: string,
	reasoncode: string,
	actionby: string,
	notes: string
}
export interface sendIntroActionState {
	caseno: string,
	refer: string,
	usertype: string,
	token: string,
	casetype: string,
	handler: string,
	id: string,
	response: string
}
interface getReportState {
	sec: string,
	sv: string,
	desc: string,
	idb: string
}
interface clientState {
	title: string,
	firstname: string,
	lastname: string,
	address1: string,
	address2: string,
	address3: string,
	address4: string,
	postcode: string,
	email: string,
	mobile: string
}
interface propertyState {
	address: string,
	address1: string,
	address2: string,
	address3: string,
	address4: string,
	postcode: string
}
export interface teamMemberState {
	email: string,
	name: string,
	phone: string,
	job: string
}
export interface teamState {
	email: string,
	handler: string,
	id: string,
	members: teamMemberState[],
	name: string,
	phone: string,
	job: string,
	teamname: string
}
export interface reportCaseState {
	ATPReceivedDatePurchase: string,
	CashPurchase: string,
	Client01Correspondentindex: string,
	ClientComplaintInfoReturnedOnDatePurchase: string,
	ClientComplaintInfoSentOnDatePurchase: string,
	ContractsReceivedDatePurchase: string,
	ExchangeDatePurchase: string,
	GovScheme: string,
	HelpToBuyForm1SentDate: string,
	MatterTypeCode: string,
	OutstandingIssues: string,
	PartExNotes: string,
	PaymentForAdvanceCostsAndSearchesReceivedDate: string,
	PropertyPurchaseIndex: string,
	PropertySaleIndex: string,
	ReportedToClientDatePurchase: string,
	ReservationDate: string,
	SearchesExpectedReturnedDatePurchase: string,
	SearchesOrderedDatePurchase: string,
	SearchesReceivedDatePurchase: string,
	SignedMortgageReceivedDate: string,
	casekey: string
}
export interface bricklaneRowState {
	CCLReceived: string,
	CaseStatusDescription: string,
	Client01FullName: string,
	Client02FullName: string,
	CompletionDateSale: string,
	ContractSent: string,
	ContractSentQ: string,
	EnquiriesReceivedDate: string,
	EnquiriesReceivedQ: string,
	EnquiriesRepliedDate: string,
	ExchangeDate: string,
	Exchanged: string,
	FeeEarner: string,
	FileClosedDate: string,
	FileOpened: string,
	Introducer: string,
	LPE1sentToClient: string,
	LPE1senttoManagementCompany: string,
	LPE1toClientQ: string,
	LPE1toManagementCompanyQ: string,
	MatterCancelledDate: string,
	MatterTypeCode: string,
	RepliestoEnquiriesReceivedQ: string,
	StartMonth: string,
	Tenure: string,
	TransactionPropertyAddress: string,
	TransactionPropertyPostcode: string,
	casekey: string,
	casetype: string
}
export interface garnetRowState {
	AllSearchesReceivedQ: string,
	CaseStatusDescription: string,
	ClassOfTitle: string,
	Client01FullName: string,
	Client01K16Complete: string,
	Client02FullName: string,
	Client02K16Complete: string,
	CompletionDate: string,
	ContractPackReceivedDate: string,
	DepositRequestedFromClient: string,
	DraftContractsArrivedQ: string,
	EnquiriesCompleteDate: string,
	EnquiriesRaisedDate: string,
	EnquiriesResponseDate: string,
	EnquiriesSentQ: string,
	ExchangeDate: string,
	Exchanged: string,
	ExistingLender01: string,
	ExistingLender01ChargeDate: string,
	ExistingLender02: string,
	ExistingLender02ChargeDate: string,
	FeeEarner: string,
	FileCancelled: string,
	FileClosedDate: string,
	FileOpened: string,
	Introducer: string,
	LeaseTerm: string,
	OELastEdition: string,
	OS1Expiry: string,
	OS1Received: string,
	OS2Expiry: string,
	OS2Received: string,
	OfficeCopiesReceivedFreehold: string,
	OfficeCopiesReceivedLeasehold: string,
	PriceAtRegistration: string,
	RepliestoEnquiries: string,
	ReportOnTitleSent: string,
	ReportonTitleSentQ: string,
	Restrictions: string,
	SearchesChecklistOrderedDate: string,
	SearchesChecklistReceivedDate: string,
	SearchesOrderedQ: string,
	StartMonth: string,
	Tenure: string,
	TitleReviewCompleteDate: string,
	TransactionPropertyAddress: string,
	TransactionPropertyPostcode: string,
	casekey: string,
	casetype: string
}
export interface reportSiteState {
	SchemeDescription: string,
	cases: reportCaseState[]
}
export interface reportState {
	isGenerating: boolean,
	isSaving: boolean,
	sites: reportSiteState[],
	rows: bricklaneRowState[] | garnetRowState[],
	sv: string,
	reportTop: number
}
export interface actionItemState {
	casetype: string,
	reason: string,
	reasoncode: string,
	type: string
}
export interface actionsState {
	common: actionItemState[],
	P: actionItemState[],
	R: actionItemState[],
	S: actionItemState[]
}
export interface caseActionsState {
	actionby: string,
	caseno: string,
	id: string,
	notes: string,
	raised: string,
	reason: string,
	reasoncode: string,
	responded: string,
	response: string,
	type: string,
	readDate: string,
}
export interface caseDatesState {
	valuation_booked: string | null;
	mortgage_completed: string | null;
	valuation_completed: string | null;
}
export interface caseState {
	caseno: string,
	description: string,
	type: string,
	casetype: string,
	client1: clientState | null,
	client2: clientState | null,
	client3: clientState | null,
	client4: clientState | null,
	property: propertyState | null,
	details: caseListState | null,
	actions: caseActionsState[],
	IntroducerDates: caseDatesState,
	selectedAction: caseActionsState | null,
	historyData: caseHistoryItemState[]
}
export interface caseHistoryItemState {
	HistoryDate: string,
	Details: string,
	tab: string,
	actions: string,
	actioned: string,
	historyrowid: string
}
interface caseRequestState {
	details: caseListState | null,
	caseno: string,
	type: string
}
interface TrackerChartOptionItem {
	id: string;
	message: string;
	weight: number;
	value: string | null;
	stage: string;
	isVisible: boolean;
}
interface TrackerChartOption {
	stage: string;
	items: TrackerChartOptionItem[];
}
export interface TrackerChartOptions {
	Purchase: TrackerChartOption[];
	Sale: TrackerChartOption[];
	Remortgage: TrackerChartOption[];
	SecuredLending: TrackerChartOption[];
}
interface SearchCasesPayload {
    searchStr: string;
    isWishlisted: boolean;
}
interface casesState {
	user: string,
	sortType: sortType,
	sortTypeCCE: sortType,
	sortTypeWWC: sortType,
	sortTypeIA: sortType,
	filterTeam: string,
	filterType: string,
	filterSite: string,
	filterStage: string,
	filterStatus: string[],
	filterWishlist: string,
	searchStr: string,
	cases: caseListState[],
	schemes: schemeListState[],
	case: caseState,
	linkedcase: caseState,
	teams: teamState[],
	actions: actionsState,
	request: caseRequestState,
	isLoading: boolean,
	isLoaded: boolean,
	isOpeningCase: boolean,
	isOpeningLinkedCase: boolean,
	isOpeningActions: boolean,
	isOpeningHistory: boolean,
	isOpeningTeam: boolean,
	isOpeningLinkedTeam: boolean,
	isWishlisting: boolean,
	isUpdatingDates: boolean,
	isChasing: boolean,
	isCalling: boolean,
	isEmailing: boolean,
	isPushing: boolean,
	isSendingIntroResponse: boolean,
	report: reportState,
	htmlSSRS: string,
	iframeSsrsSrc: string,
	trackerChartOptions: TrackerChartOptions,
	totalCases: number,
	rowsPerPage: number,
	skip: number,
}

const defaultTrackerChartOptions: TrackerChartOptions = {
	Purchase: [
		{
			"stage": "On-Boarding",
			"items": [
				{
					"id": "cclsent",
					"message": "Initial Paperwork Sent",
					"weight": 15,
					"value": "24/07/2023",
					"stage": "On-Boarding",
					"isVisible": true
				},
				{
					"id": "cclacceptable",
					"message": "Initial Paperwork Received",
					"weight": 15,
					"value": "04/12/2023",
					"stage": "On-Boarding",
					"isVisible": true
				},
				{
					"id": "fundsvalid",
					"message": "Client Search Monies Received",
					"weight": 18,
					"value": "04/12/2023",
					"stage": "On-Boarding",
					"isVisible": true
				},
			]
		},
		{
			"stage": "Reporting",
			"items": [
				{
					"id": "contractsreceived",
					"message": "Draft Contracts Received",
					"weight": 15,
					"value": "04/12/2023",
					"stage": "Reporting",
					"isVisible": true
				},
				{
					"id": "searchesraised",
					"message": "Searches Requested",
					"weight": 12,
					"value": null,
					"stage": "Reporting",
					"isVisible": true
				},
				{
					"id": "searchesreceived",
					"message": "Searches Received",
					"weight": 12,
					"value": null,
					"stage": "Reporting",
					"isVisible": true
				},
				{
					"id": "reportontitle",
					"message": "Report Sent",
					"weight": 12,
					"value": null,
					"stage": "Reporting",
					"isVisible": true
				},
				{
					"id": "mortgagereceived",
					"message": "Mortgage Offer Received",
					"weight": 15,
					"value": "04/12/2023",
					"stage": "Reporting",
					"isVisible": true
				},
				{
					"id": "mortgagesent",
					"message": "Mortgage Offer Report Sent",
					"weight": 18,
					"value": "04/12/2023",
					"stage": "Reporting",
					"isVisible": true
				},
			]
		},
		{
			"stage": "Pre-Exchange",
			"items": [
				{
					"id": "enquiriesraised",
					"message": "Enquiries Satisfied",
					"weight": 12,
					"value": "10/01/2025",
					"stage": "Pre-Exchange",
					"isVisible": true
				},
				{
					"id": "contractsigned",
					"message": "Received Contract From Client",
					"weight": 20,
					"value": "04/12/2023",
					"stage": "Pre-Exchange",
					"isVisible": true
				},
			]
		},
		{
			"stage": "Pre-Completion",
			"items": [
				{
					"id": "exchangedate",
					"message": "Exchanged",
					"weight": 12,
					"value": null,
					"stage": "Pre-Completion",
					"isVisible": true
				},
				{
					"id": "completiondate",
					"message": "Anticipated Completion",
					"weight": 12,
					"value": null,
					"stage": "Pre-Completion",
					"isVisible": true
				}
			]
		}
	],
	Sale: [
		{
			"stage": "On-Boarding",
			"items": [
				{
					"id": "cclsent",
					"message": "Initial Paperwork Sent",
					"weight": 20,
					"value": "16/05/2024",
					"stage": "On-Boarding",
					"isVisible": true
				},
				{
					"id": "cclacceptable",
					"message": "Initial Paperwork Received",
					"weight": 20,
					"value": "16/05/2024",
					"stage": "On-Boarding",
					"isVisible": true
				},
				{
					"id": "fundsvalid",
					"message": "Client Search Monies Received",
					"weight": 20,
					"value": "16/05/2024",
					"stage": "On-Boarding",
					"isVisible": true
				},
			]
		},
		{
			"stage": "Contracts",
			"items": [
				{
					"id": "contractsent",
					"message": "Contract Sent to Client",
					"weight": 20,
					"value": null,
					"stage": "Contracts",
					"isVisible": true
				},
				{
					"id": "contractsreceived",
					"message": "Signed Contract Received from Client",
					"weight": 20,
					"value": null,
					"stage": "Contracts",
					"isVisible": true
				},
				{
					"id": "contractsenttobuyer",
					"message": "Draft Contracts Sent to Buyers Solicitor",
					"weight": 20,
					"value": "16/05/2024",
					"stage": "Contracts",
					"isVisible": true
				},
			]
		},
		{
			"stage": "Dealing With Enquiries",
			"items": [
				{
					"id": "enquiriesreceived",
					"message": "Enquiries Received",
					"weight": 20,
					"value": null,
					"stage": "Dealing With Enquiries",
					"isVisible": true
				},
				{
					"id": "enquiriesreplied",
					"message": "Enquiries Replied To",
					"weight": 20,
					"value": null,
					"stage": "Dealing With Enquiries",
					"isVisible": true
				},
			]
		},
		{
			"stage": "Pre-Completion",
			"items": [
				{
					"id": "exchangedate",
					"message": "Exchanged",
					"weight": 10,
					"value": null,
					"stage": "Pre-Completion",
					"isVisible": true
				},
				{
					"id": "completiondate",
					"message": "Anticipated Completion",
					"weight": 10,
					"value": null,
					"stage": "Pre-Completion",
					"isVisible": true
				}
			]
		}
	],
	Remortgage: [
		{
			"stage": "On-Boarding",
			"items": [
				{
					"id": "cclsent",
					"message": "Initial Paperwork Sent",
					"weight": 20,
					"value": "19/08/2021",
					"stage": "On-Boarding",
					"isVisible": true
				},
				{
					"id": "cclacceptable",
					"message": "Initial Paperwork Received",
					"weight": 20,
					"value": "14/09/2021",
					"stage": "On-Boarding",
					"isVisible": true
				},
			]
		},
		{
			"stage": "Title Checking",
			"items": [
				{
					"id": "deedsrequested",
					"message": "Deeds/Official Copies Requested",
					"weight": 20,
					"value": null,
					"stage": "Title Checking",
					"isVisible": true
				},
				{
					"id": "deedsreceived",
					"message": "Deeds/Official Copies Received",
					"weight": 20,
					"value": null,
					"stage": "Title Checking",
					"isVisible": true
				},
			]
		},
		{
			"stage": "Financing",
			"items": [
				{
					"id": "mortgagereceived",
					"message": "Mortgage Offer Received",
					"weight": 20,
					"value": "08/09/2021",
					"stage": "Financing",
					"isVisible": true
				},
				{
					"id": "mortgagesent",
					"message": "Mortgage Deed Sent to Client",
					"weight": 20,
					"value": "13/09/2021",
					"stage": "Financing",
					"isVisible": true
				},
				{
					"id": "moniesreceived",
					"message": "Completion Monies Received",
					"weight": 20,
					"value": null,
					"stage": "Financing",
					"isVisible": true
				},
			]
		},
		{
			"stage": "Completing",
			"items": [
				{
					"id": "cotsentdate",
					"message": "Set-Up",
					"weight": 10,
					"value": "20/12/2021",
					"stage": "Completing",
					"isVisible": true
				},
				{
					"id": "completiondate",
					"message": "Anticipated Completion",
					"weight": 10,
					"value": null,
					"stage": "Completing",
					"isVisible": true
				}
			]
		}
	],
	SecuredLending: [
		{
			"stage": "Secured Lending",
			"items": [
				{
					"id": "LenderInstructionsReceivedDate",
					"message": "Lender Instructions Received",
					"weight": 20,
					"value": "19/08/2021",
					"stage": "Secured Lending",
					"isVisible": true
				},
				{
					"id": "CostsUndertakingReceivedDate",
					"message": "Costs Undertaking Received",
					"weight": 20,
					"value": "19/08/2021",
					"stage": "Secured Lending",
					"isVisible": true
				},
				{
					"id": "RepliestoSchedofReqReceivedDate",
					"message": "Replies to Schedule of Requirements Received",
					"weight": 20,
					"value": "19/08/2021",
					"stage": "Secured Lending",
					"isVisible": true
				},
				{
					"id": "FacilityLetterReceivedDate",
					"message": "Facility Letter Received",
					"weight": 20,
					"value": "19/08/2021",
					"stage": "Secured Lending",
					"isVisible": true
				},
				{
					"id": "SecurityDocumentsIssuedDate",
					"message": "Security Documents Issued",
					"weight": 20,
					"value": "19/08/2021",
					"stage": "Secured Lending",
					"isVisible": true
				},
				{
					"id": "TitleCheckDoneandEnqRaisedDate",
					"message": "Title Check Done and Enquiries Raised",
					"weight": 20,
					"value": "19/08/2021",
					"stage": "Secured Lending",
					"isVisible": true
				},
				{
					"id": "ReponTitleCertofTitleSentDate",
					"message": "Report on Title/Certificate of Title Sent to Lender",
					"weight": 20,
					"value": "19/08/2021",
					"stage": "Secured Lending",
					"isVisible": true
				},
				{
					"id": "FinalReptoEnquiriesReceivedDate",
					"message": "Final Replies to Enquiries Received",
					"weight": 20,
					"value": "19/08/2021",
					"stage": "Secured Lending",
					"isVisible": true
				},
				{
					"id": "SignedSecDocumentsReceivedDate",
					"message": "Signed Security Documents Received",
					"weight": 20,
					"value": "19/08/2021",
					"stage": "Secured Lending",
					"isVisible": true
				},
				{
					"id": "CompleteNowButtonPressedDate",
					"message": "Complete Now Pressed",
					"weight": 20,
					"value": "19/08/2021",
					"stage": "Secured Lending",
					"isVisible": true
				},
			]
		},
	],
};

const co = {
	user: '',
	sortType: {
		type: 'Opened',
		reverse: true
	},
	sortTypeCCE: {
		type: 'Raised',
		reverse: false
	},
	sortTypeWWC: {
		type: 'Raised',
		reverse: false
	},
	sortTypeIA: {
		type: 'Raised',
		reverse: false
	},
	filterTeam: '',
	filterType: '',
	filterSite: '',
	filterStage: '',
	filterStatus: ['0', '1', '2', '3', '4', '5', '6', '7'],
	filterWishlist: '',
	searchStr: '',
	cases: [],
	schemes: [],
	case: {
		caseno: '',
		description: '',
		type: '',
		casetype: '',
		handler: '',
		client1: null,
		client2: null,
		client3: null,
		client4: null,
		property: null,
		details: null,
		actions: [],
		IntroducerDates: {
			valuation_booked: null,
			mortgage_completed: null,
			valuation_completed: null
		},
		selectedAction: null,
		historyData: []
	},
	linkedcase: {
		caseno: '',
		description: '',
		type: '',
		casetype: '',
		handler: '',
		client1: null,
		client2: null,
		client3: null,
		client4: null,
		property: null,
		details: null,
		actions: [],
		IntroducerDates: {
			valuation_booked: null,
			mortgage_completed: null,
			valuation_completed: null
		},
		selectedAction: null,
		historyData: []
	},
	teams: [],
	actions: {
		common: [],
		P: [],
		R: [],
		S: []
	},
	request: {
		details: null,
		caseno: '',
		type: ''
	},
	isLoading: false,
	isLoaded: false,
	isOpeningCase: false,
	isOpeningLinkedCase: false,
	isOpeningActions: false,
	isOpeningHistory: false,
	isOpeningTeam: false,
	isOpeningLinkedTeam: false,
	isWishlisting: false,
	isUpdatingDates: false,
	isChasing: false,
	isCalling: false,
	isEmailing: false,
	isPushing: false,
	isSendingIntroResponse: false,
	report: {
		isGenerating: false,
		isSaving: false,
		sites: [],
		rows: [],
		sv: '',
		reportTop: 0
	},
	htmlSSRS: '',
	iframeSsrsSrc: '',
	trackerChartOptions: defaultTrackerChartOptions,
	totalCases: 300,
	rowsPerPage: 50,
	skip: 0
}
const initialState: casesState = co;

const getStage = (t: trackerItemState[]): stageType => {
	let o: stageType = {};
	for (let i of t) {
		let s = '0';
		if (i.stage === 'Exchanged and Completed') { s = '8'; }
		else if (i.stage === 'Pre-Completion' || i.stage === 'Completing') { s = '7'; }
		else if (i.stage === 'Pre-Exchange' || i.stage === 'Financing' || i.stage === 'Dealing With Enquiries') { s = '6'; }
		else if (i.stage === 'Reporting' || i.stage === 'Title Checking' || i.stage === 'Contracts') { s = '5'; }
		else if (i.stage === 'On-Boarding') { s = '4'; }
		else if (i.stage === 'Onboarded with Searches') { s = '3'; }
		else if (i.stage === 'No Client Paperwork') { s = '2'; }
		else if (i.stage === 'Pre-Onboarding') { s = '1'; }
		if (o[s] !== false) {
			o[s] = (i.value !== '' && i.value !== null);
		}
	}

	const anyStageTrue = Object.entries(o).some(([k, v]) => k !== '0' && v === true);
	o['0'] = !anyStageTrue;
	return o;
}

function compareTeam(a: teamState, b: teamState) {
	const teama = (a.teamname === null ? '' : a.teamname.trim());
	const teamb = (b.teamname === null ? '' : b.teamname.trim());
	if (teama < teamb) {
		return -1;
	}
	if (teama > teamb) {
		return 1;
	}
	return 0;
}

function compareReference(a: caseListState, b: caseListState) {
	if (a.caseno.trim() < b.caseno.trim()) {
		return -1;
	}
	if (a.caseno.trim() > b.caseno.trim()) {
		return 1;
	}
	return 0;
}
function compareName(a: caseListState, b: caseListState) {
	if (a.description.trim().toLowerCase() < b.description.trim().toLowerCase()) {
		return -1;
	}
	if (a.description.trim().toLowerCase() > b.description.trim().toLowerCase()) {
		return 1;
	}
	return 0;
}
function compareOpened(a: caseListState, b: caseListState) {
	var partsa = a.opened.split("/");
	var partsb = b.opened.split("/");
	var dta = new Date(parseInt(partsa[2]), parseInt(partsa[1]) - 1, parseInt(partsa[0]));
	var dtb = new Date(parseInt(partsb[2]), parseInt(partsb[1]) - 1, parseInt(partsb[0]));

	if (dta < dtb) {
		return -1;
	}
	if (dta > dtb) {
		return 1;
	}
	return 0;
}
function compareType(a: caseListState, b: caseListState) {
	if (a.type < b.type) {
		return -1;
	}
	if (a.type > b.type) {
		return 1;
	}
	return 0;
}
function compareSite(a: caseListState, b: caseListState) {
	const sitea = (a.site === null ? '' : a.site);
	const siteb = (b.site === null ? '' : b.site);
	if (sitea.trim().toLowerCase() < siteb.trim().toLowerCase()) {
		return -1;
	}
	if (sitea.trim().toLowerCase() > siteb.trim().toLowerCase()) {
		return 1;
	}
	return 0;
}
function compareAddress(a: caseListState, b: caseListState) {
	if (a.address.trim().toLowerCase() < b.address.trim().toLowerCase()) {
		return -1;
	}
	if (a.address.trim().toLowerCase() > b.address.trim().toLowerCase()) {
		return 1;
	}
	return 0;
}
function compareWishlist(a: caseListState, b: caseListState) {
	var partsa = (a.wishlisted ? a.wishlisted.split(' ')[0].split('/') : ['01', '01', '1900']);
	var partsb = (b.wishlisted ? b.wishlisted.split(' ')[0].split('/') : ['01', '01', '1900']);
	var dta = new Date(parseInt(partsa[2]), parseInt(partsa[1]) - 1, parseInt(partsa[0]));
	var dtb = new Date(parseInt(partsb[2]), parseInt(partsb[1]) - 1, parseInt(partsb[0]));

	if (dta < dtb) {
		return -1;
	}
	if (dta > dtb) {
		return 1;
	}
	return 0;
}
function compareProgress(a: caseListState, b: caseListState) {
	if (a.progress < b.progress) {
		return -1;
	}
	if (a.progress > b.progress) {
		return 1;
	}
	return 0;
}

function collapseCases(cases: caseListState[]) {
	for (var item of cases) {
		item.selected = false;
	}
	return cases;
}

export function getProgress(item: caseListState, caseType: keyof TrackerChartOptions, trackerChartOptions: TrackerChartOptions) {
	let ff = 0;
	let tot = 0;
	let p = 0;

	if (item.tracker) {
		for (let value of Object.values(item.tracker)) {
			for (let subValue of Object.values(trackerChartOptions[caseType])) {
				if (subValue.items) {
					for (const trackerChartColumn of subValue.items) {
						if (trackerChartColumn.message === value.message && trackerChartColumn.isVisible) {
							tot += value.weight;
							if (value.value && (caseType === "SecuredLending" ? value.stage === "Secured Lending" : true)) {
								ff += value.weight;
								continue;
							}
						}
					}
				}
			}
		}
		p = (1.0 / tot) * ff;
	}
	return p;
}

export const getCases = createAsyncThunk(
	'cases/getcases',
	async (get: getCasesState, _thunkAPI: any) => {
		const casesState = store.getState().cases;

		try {
			let formdata = new FormData();
			formdata.append("user", get.user);
			formdata.append("refer", get.user);
			formdata.append("security", get.security);
			formdata.append("session", '');
			if (casesState.rowsPerPage !== -1) {
				formdata.append("skip", (casesState.skip * casesState.rowsPerPage).toString());
				formdata.append("rowsPerPage", casesState.rowsPerPage.toString());
			}

			return fetch(process.env.REACT_APP_API_BACKEND_URL + 'getcases_cs.php', {
				method: 'POST',
				body: formdata
			})
				.then(async (response) => {
					return await response.text();
				})
				.catch((error) => {
					console.error(error);
				});
		} catch (error) {
			console.error(error);
		}
	}
);
export const updateCaseAction = createAsyncThunk(
	'cases/updateCaseAction',
	async (get: updateCaseActionState, _thunkAPI: any) => {
		try {
			let formdata = new FormData();
			formdata.append("id", get.id);
			formdata.append("readDate", get.readDate);

			return fetch(process.env.REACT_APP_API_BACKEND_URL + 'updateCaseAction.php', {
				method: 'POST',
				body: formdata
			})
				.then(async (response) => {
					return await response.text();
				})
				.catch((error) => {
					console.error(error);
				});
		} catch (error) {
			console.error(error);
		}
	}
);
export const getCase = createAsyncThunk(
	'cases/getcase',
	async (get: getCaseState, _thunkAPI: any) => {
		try {
			let formdata = new FormData();
			formdata.append("ccaseno", get.caseno);
			formdata.append("type", get.type);
			formdata.append("refer", get.id);
			formdata.append("security", get.token);
			formdata.append("session", '');

			return fetch(process.env.REACT_APP_API_BACKEND_URL + 'getcase_cs.php', {
				method: 'POST',
				body: formdata
			})
				.then(async (response) => {
					return await response.text();
				})
				.catch((error) => {
					console.error(error);
				});
		} catch (error) {
			console.error(error);
		}
	}
);
export const getLinkedCase = createAsyncThunk(
	'cases/getlinkedcase',
	async (get: getCaseState, _thunkAPI: any) => {
		try {
			let formdata = new FormData();
			formdata.append("ccaseno", get.caseno);
			formdata.append("type", get.type);
			formdata.append("refer", get.id);
			formdata.append("security", get.token);
			formdata.append("session", '');

			return fetch(process.env.REACT_APP_API_BACKEND_URL + 'getcase_cs.php', {
				method: 'POST',
				body: formdata
			})
				.then(async (response) => {
					return await response.text();
				})
				.catch((error) => {
					console.error(error);
				});
		} catch (error) {
			console.error(error);
		}
	}
);
export const wishlistCase = createAsyncThunk(
	'cases/wishlistcase',
	async (get: wishlistCaseState, _thunkAPI: any) => {
		try {
			let formdata = new FormData();
			formdata.append("ccaseno", get.caseno);
			formdata.append("refer", get.id);
			formdata.append("usertype", get.usertype);
			formdata.append("security", get.token);
			formdata.append("casetype", get.casetype);
			formdata.append("session", '');
			formdata.append("type", get.type);
			formdata.append("month", get.month.toString());

			return fetch(process.env.REACT_APP_API_BACKEND_URL + 'wishlistcase.php', {
				method: 'POST',
				body: formdata
			})
				.then(async (response) => {
					return await response.text();
				})
				.catch((error) => {
					console.error(error);
				});
		} catch (error) {
			console.error(error);
		}
	}
);
export const removeWishlist = createAsyncThunk(
	'cases/removewishlist',
	async (get: removeWishlistState, _thunkAPI: any) => {
		try {
			let formdata = new FormData();
			formdata.append("ccaseno", get.caseno);
			formdata.append("refer", get.id);
			formdata.append("security", get.token);
			formdata.append("session", '');

			return fetch(process.env.REACT_APP_API_BACKEND_URL + 'removewishlist.php', {
				method: 'POST',
				body: formdata
			})
				.then(async (response) => {
					return await response.text();
				})
				.catch((error) => {
					console.error(error);
				});
		} catch (error) {
			console.error(error);
		}
	}
);
export const updateCaseDates = createAsyncThunk(
	'cases/updatecasedates',
	async (get: updateCaseDatesState, _thunkAPI: any) => {
		try {
			let formdata = new FormData();
			formdata.append("ccaseno", get.caseno);
			formdata.append("refer", get.id);
			formdata.append("usertype", get.usertype);
			formdata.append("security", get.token);
			formdata.append("casetype", get.casetype);
			formdata.append("handler", get.handler);
			formdata.append("valuation_booked", get.valuation_booked);
			formdata.append("mortgage_completed", get.mortgage_completed);
			formdata.append("valuation_completed", get.valuation_completed);

			return fetch(process.env.REACT_APP_API_BACKEND_URL + 'updatecasedates.php', {
				method: 'POST',
				body: formdata
			})
				.then(async (response) => {
					return await response.text();
				})
				.catch((error) => {
					console.error(error);
				});
		} catch (error) {
			console.error(error);
		}
	}
);
export const getReportData = createAsyncThunk(
	'cases/getreportdata',
	async (get: getReportState, _thunkAPI: any) => {
		try {
			let formdata = new FormData();
			formdata.append("sv", get.sv);
			formdata.append("desc", get.desc);
			formdata.append("idb", get.idb);

			return fetch(process.env.REACT_APP_API_BACKEND_URL + 'getreportdata.php', {
				method: 'POST',
				body: formdata
			})
				.then(async (response) => {
					return await response.text();
				})
				.catch((error) => {
					console.error(error);
				});
		} catch (error) {
			console.error(error);
		}
	}
);
export const getReportSSRS = createAsyncThunk(
	'cases/getreportssrs',
	async (get: string, _thunkAPI: any) => {
		try {
			return fetch(process.env.REACT_APP_API_BACKEND_URL + get, {})
				.then(async (response) => {
					return await response.text();
				})
				.catch((error) => {
					console.error(error);
				});
		} catch (error) {
			console.error(error);
		}
	}
);
export const getReportXlsx = createAsyncThunk(
	'cases/getreportxlsx',
	async (get: getReportState, _thunkAPI: any) => {
		try {
			let formdata = new FormData();
			let url = 'getreportxlsx.php';
			if (get.sv === 'garnet') {
				url = 'getgarnetxlsx.php';
				formdata.append("id", get.idb);
				formdata.append("sec", get.sec);
			} else if (get.sv === 'bricklane') {
				url = 'getbricklanexlsx.php';
				formdata.append("id", get.idb);
				formdata.append("sec", get.sec);
			} else if (get.sv === 'brickmoor') {
				url = 'getbrickmoorxlsx.php';
				formdata.append("id", get.idb);
				formdata.append("sec", get.sec);
			} else {
				formdata.append("sv", get.sv);
				formdata.append("desc", get.desc);
				formdata.append("idb", get.idb);
			}

			return fetch(process.env.REACT_APP_API_BACKEND_URL + url, {
				method: 'POST',
				body: formdata
			})
				.then(async (response) => {
					return await response.text();
				})
				.catch((error) => {
					console.error(error);
				});
		} catch (error) {
			console.error(error);
		}
	}
);

export const chaseCase = createAsyncThunk(
	'cases/chasecase',
	async (get: chaseCaseState, _thunkAPI: any) => {
		try {
			let formdata = new FormData();
			formdata.append("ccaseno", get.caseno);
			formdata.append("refer", get.id);
			formdata.append("usertype", get.usertype);
			formdata.append("security", get.token);
			formdata.append("casetype", get.casetype);
			formdata.append("handler", get.handler);
			formdata.append("type", get.type);
			formdata.append("reason", get.reason);
			formdata.append("reasoncode", get.reasoncode);
			formdata.append("actionby", get.actionby);
			formdata.append("notes", get.notes);

			return fetch(process.env.REACT_APP_API_BACKEND_URL + 'chasecase.php', {
				method: 'POST',
				body: formdata
			})
				.then(async (response) => {
					return await response.text();
				})
				.catch((error) => {
					console.error(error);
				});
		} catch (error) {
			console.error(error);
		}
	}
);

export const callCase = createAsyncThunk(
	'cases/callcase',
	async (get: chaseCaseState, _thunkAPI: any) => {
		try {
			let formdata = new FormData();
			formdata.append("ccaseno", get.caseno);
			formdata.append("refer", get.id);
			formdata.append("usertype", get.usertype);
			formdata.append("security", get.token);
			formdata.append("casetype", get.casetype);
			formdata.append("handler", get.handler);
			formdata.append("type", get.type);
			formdata.append("reason", get.reason);
			formdata.append("reasoncode", get.reasoncode);
			formdata.append("actionby", get.actionby);
			formdata.append("notes", get.notes);

			return fetch(process.env.REACT_APP_API_BACKEND_URL + 'chasecase.php', {
				method: 'POST',
				body: formdata
			})
				.then(async (response) => {
					return await response.text();
				})
				.catch((error) => {
					console.error(error);
				});
		} catch (error) {
			console.error(error);
		}
	}
);

export const pushCase = createAsyncThunk(
	'cases/pushcase',
	async (get: chaseCaseState, _thunkAPI: any) => {
		try {
			let formdata = new FormData();
			formdata.append("ccaseno", get.caseno);
			formdata.append("refer", get.id);
			formdata.append("usertype", get.usertype);
			formdata.append("security", get.token);
			formdata.append("casetype", get.casetype);
			formdata.append("handler", get.handler);
			formdata.append("type", get.type);
			formdata.append("reason", '');
			formdata.append("reasoncode", get.reasoncode);
			formdata.append("actionby", get.actionby);
			formdata.append("notes", get.reason);

			return fetch(process.env.REACT_APP_API_BACKEND_URL + 'chasecase.php', {
				method: 'POST',
				body: formdata
			})
				.then(async (response) => {
					return await response.text();
				})
				.catch((error) => {
					console.error(error);
				});
		} catch (error) {
			console.error(error);
		}
	}
);

export const sendActionResponse = createAsyncThunk(
	'cases/sendactionresponse',
	async (get: sendIntroActionState, _thunkAPI: any) => {
		try {
			let formdata = new FormData();
			formdata.append("ccaseno", get.caseno);
			formdata.append("refer", get.refer);
			formdata.append("usertype", get.usertype);
			formdata.append("security", get.token);
			formdata.append("casetype", get.casetype);
			formdata.append("handler", get.handler);
			formdata.append("id", get.id);
			formdata.append("response", get.response);

			return fetch(process.env.REACT_APP_API_BACKEND_URL + 'sendresponse.php', {
				method: 'POST',
				body: formdata
			})
				.then(async (response) => {
					return await response.text();
				})
				.catch((error) => {
					console.error(error);
				});
		} catch (error) {
			console.error(error);
		}
	}
);

export const updateTrackerChartData = createAsyncThunk(
	'cases/updateTrackerChartData',
	async (get: updatedTrackerChartDataState, _thunkAPI: any) => {
		try {
			let formdata = new FormData();
			formdata.append("casekey", get.casekey);
			formdata.append("caseType", get.caseType);
			formdata.append("chartData", get.chartData);

			return fetch(process.env.REACT_APP_API_BACKEND_URL + 'updateTrackerChartData.php', {
				method: 'POST',
				body: formdata
			})
				.then(async (response) => {
					return await response.text();
				})
				.catch((error) => {
					console.error(error);
				});
		} catch (error) {
			console.error(error);
		}
	}
);

export const casesSlice = createSlice({
	name: 'cases',
	initialState,
	reducers: {
		setUser: (state, action: PayloadAction<string>) => {
			state.user = action.payload;
		},
		setSortType: (state, action: PayloadAction<sortType>) => {
			if (typeof action.payload.reverse === 'undefined') {
				if (action.payload.type === state.sortType.type) {
					action.payload.reverse = !state.sortType.reverse;
				} else {
					action.payload.reverse = false;
				}
			}
			state.sortType = action.payload;
			switch (state.sortType.type) {
				case 'Reference':
					state.cases.sort(compareReference);
					break;
				case 'Name':
					state.cases.sort(compareName);
					break;
				case 'Opened':
					state.cases.sort(compareOpened);
					break;
				case 'Type':
					state.cases.sort(compareType);
					break;
				case 'Site':
					state.cases.sort(compareSite);
					break;
				case 'Address':
					state.cases.sort(compareAddress);
					break;
				case 'Wishlist':
					state.cases.sort(compareWishlist);
					break;
				case 'Progress':
					state.cases.sort(compareProgress);
					break;
			}
			if (state.sortType.reverse) {
				state.cases.reverse();
			}
			state.cases = collapseCases(state.cases);
		},
		setSortTypeCCE: (state, action: PayloadAction<sortType>) => {
			if (typeof action.payload.reverse === 'undefined') {
				if (action.payload.type === state.sortTypeCCE.type) {
					action.payload.reverse = !state.sortTypeCCE.reverse;
				} else {
					action.payload.reverse = false;
				}
			}
			state.sortTypeCCE = action.payload;
		},
		setSortTypeWWC: (state, action: PayloadAction<sortType>) => {
			if (typeof action.payload.reverse === 'undefined') {
				if (action.payload.type === state.sortTypeWWC.type) {
					action.payload.reverse = !state.sortTypeWWC.reverse;
				} else {
					action.payload.reverse = false;
				}
			}
			state.sortTypeWWC = action.payload;
		},
		setSortTypeIA: (state, action: PayloadAction<sortType>) => {
			if (typeof action.payload.reverse === 'undefined') {
				if (action.payload.type === state.sortTypeIA.type) {
					action.payload.reverse = !state.sortTypeIA.reverse;
				} else {
					action.payload.reverse = false;
				}
			}
			state.sortTypeIA = action.payload;
		},
		setFilterTeam: (state, action: PayloadAction<string>) => {
			state.filterTeam = action.payload;
		},
		setFilterType: (state, action: PayloadAction<string>) => {
			state.filterType = action.payload;
		},
		setFilterSite: (state, action: PayloadAction<string>) => {
			state.filterSite = action.payload;
		},
		setFilterStage: (state, action: PayloadAction<string>) => {
			state.filterStage = action.payload;
		},
		setFilterStatus: (state, action: PayloadAction<string[]>) => {
			state.filterStatus = action.payload;
		},
		setFilterWishlist: (state, action: PayloadAction<string>) => {
			state.filterWishlist = action.payload;
		},
		setCaseNo: (state, action: PayloadAction<caseListState>) => {
			state.request.details = action.payload;
			state.request.caseno = action.payload.caseno;
			state.request.type = action.payload.type.charAt(0);
		},
		setCase: (state, action: PayloadAction<caseState | any>) => {
			state.case = action.payload;
		},
		setTrackerData: (state, action: PayloadAction<trackerItemState[]>) => {
			if (state.case.details) {
				state.case.details.tracker = action.payload;
			}
		},
		setTrackerChartOptions: (state, action: PayloadAction<any>) => {
			if (state.trackerChartOptions) {
				state.trackerChartOptions = action.payload;
			}
		},
		setRowsPerPage: (state: casesState, action: PayloadAction<string>) => {
			state.rowsPerPage = Number(action.payload);
		},
		setSkip: (state: casesState, action: PayloadAction<string>) => {
			state.skip = Number(action.payload);
		},
		searchCases: (state: casesState, action: PayloadAction<SearchCasesPayload>) => {
			state.isLoaded = false;
			state.searchStr = action.payload.searchStr;
			const isWishlisted = action.payload.isWishlisted;

			const fwl: boolean = (state.filterWishlist === 'W' ? true : false);
			for (const c of state.cases) {
				let cwl: boolean = (c.wishlisted !== '' && c.wishlisted !== null ? true : false);
				if ((c.caseno.includes(action.payload.searchStr) ||
					c.description.toLowerCase().includes(action.payload.searchStr.toLowerCase()) ||
					c.address.toLowerCase().includes(action.payload.searchStr.toLowerCase())) &&
					(state.filterTeam === '' || c.handler === state.filterTeam) &&
					(state.filterWishlist === '' || cwl === fwl) &&
					(state.filterType === '' || c.type === state.filterType) &&
					(state.filterSite === '' || c.siteid === (state.filterSite === '<null>' ? null : state.filterSite)) &&
					(isWishlisted ? (state.filterStage === '' || c.stage[state.filterStage]) :
					((Array.isArray(state.filterStatus) && state.filterStatus.some(stage => c.stage[stage]))))) {
					c.visible = true;
				} else {
					c.visible = false;
				}
			}
			state.isLoaded = true;
		},
		selectCase: (state: casesState, action: PayloadAction<string>) => {
			for (const c of state.cases) {
				if (c.caseno === action.payload) {
					c.selected = !c.selected;
				} else {
					c.selected = false;
				}
			}
		},
		selectLinkedCase: (state: casesState, action: PayloadAction<string>) => {
			for (const c of state.cases) {
				for (const cl of c.linked) {
					if (cl.caseno === action.payload) {
						cl.selected = !cl.selected;
						if (state.case.details) {
							for (const cdl of state.case.details.linked) {
								if (cdl.caseno === action.payload) {
									cdl.selected = cl.selected;
								}
							}
						}
					} else {
						cl.selected = false;
					}
				}
			}
		},
		clrCases: (state) => {
			state.cases = [];
			state.report.sites = [];
			state.report.rows = [];
			state.filterTeam = '';
			state.filterType = '';
			state.filterSite = '';
			state.filterStage = '';
			state.filterWishlist = '';
			state.searchStr = '';
			state.iframeSsrsSrc = '';
		},
		clrReport: (state) => {
			state.report.sites = [];
		},
		setLoading: (state: casesState, action: PayloadAction<boolean>) => {
			state.isLoading = action.payload;
		},
		setLoaded: (state: casesState, action: PayloadAction<boolean>) => {
			state.isLoaded = action.payload;
		},
		setOpeningCase: (state: casesState, action: PayloadAction<boolean>) => {
			state.isOpeningCase = action.payload;
		},
		setOpeningLinkedCase: (state: casesState, action: PayloadAction<boolean>) => {
			state.isOpeningLinkedCase = action.payload;
		},
		setOpeningActions: (state: casesState, action: PayloadAction<boolean>) => {
			state.isOpeningActions = action.payload;
		},
		setOpeningHistory: (state: casesState, action: PayloadAction<boolean>) => {
			state.isOpeningHistory = action.payload;
		},
		setOpeningTeam: (state: casesState, action: PayloadAction<boolean>) => {
			state.isOpeningTeam = action.payload;
		},
		setOpeningLinkedTeam: (state: casesState, action: PayloadAction<boolean>) => {
			state.isOpeningLinkedTeam = action.payload;
		},
		setWishlisting: (state: casesState, action: PayloadAction<boolean>) => {
			state.isWishlisting = action.payload;
		},
		setUpdatingDates: (state: casesState, action: PayloadAction<boolean>) => {
			state.isUpdatingDates = action.payload;
		},
		setGenerating: (state: casesState, action: PayloadAction<boolean>) => {
			state.report.isGenerating = action.payload;
		},
		setSaving: (state: casesState, action: PayloadAction<boolean>) => {
			state.report.isSaving = action.payload;
		},
		setChasing: (state: casesState, action: PayloadAction<boolean>) => {
			state.isChasing = action.payload;
		},
		setCalling: (state: casesState, action: PayloadAction<boolean>) => {
			state.isCalling = action.payload;
		},
		setEmailing: (state: casesState, action: PayloadAction<boolean>) => {
			state.isEmailing = action.payload;
		},
		setPushing: (state: casesState, action: PayloadAction<boolean>) => {
			state.isPushing = action.payload;
		},
		setSendingIntroResponse: (state: casesState, action: PayloadAction<boolean>) => {
			state.isSendingIntroResponse = action.payload;
		},
		setReportSV: (state: casesState, action: PayloadAction<string>) => {
			state.report.sv = action.payload;
		},
		setSelectedAction: (state: casesState, action: PayloadAction<caseActionsState | null>) => {
			state.case.selectedAction = action.payload;
		},
		setIframeSsrsSrc: (state: casesState, action: PayloadAction<string>) => {
			state.iframeSsrsSrc = action.payload;
		},
	},
	extraReducers: (builder: { addCase: (arg0: any, arg1: { (state: casesState, action: any): void; (state: any, action: any): void; }) => void; }) => {
		builder.addCase(getCases.fulfilled, (state: casesState, action: { payload: string; }) => {
			state.isLoading = false;
			state.isLoaded = true;
			try {
				const json = JSON.parse(action.payload as string);
				if (state.user !== json.id) { return; }
				state.teams = json.teams;
				state.actions = json.actions;
				state.teams.sort(compareTeam);
				state.totalCases = json.cases.length;

				const trackerChartOptions = {
					Purchase: json.trackerChartData.purchase ? JSON.parse(json.trackerChartData.purchase) : defaultTrackerChartOptions.Purchase,
					Sale: json.trackerChartData.sale ? JSON.parse(json.trackerChartData.sale) : defaultTrackerChartOptions.Sale,
					Remortgage: json.trackerChartData.remortgage ? JSON.parse(json.trackerChartData.remortgage) : defaultTrackerChartOptions.Remortgage,
					SecuredLending: json.trackerChartData.securedLending ? JSON.parse(json.trackerChartData.securedLending) : defaultTrackerChartOptions.SecuredLending
				};
				state.trackerChartOptions = trackerChartOptions;

				let sid: string = '';
				for (let i = 0; i < state.cases.length; i++) {
					const sc = state.cases[i];
					if (sc.selected) {
						sid = sc.caseno;
						break;
					}
				}
				state.cases = [];
				for (let i = 0; i < json.cases.length; i++) {
					const jc = json.cases[i];
					const updatedTracker = jc.tracker.map((item: trackerItemState) => ({
						...item,
						isVisible: item.isVisible !== undefined ? item.isVisible : true
					}));

					let caseActions = [...json.caseActions];
					let unviewActions = caseActions.filter((item) => (
						item.caseno === jc.caseno
					)).map(action => action.id);

					state.cases.push({
						caseno: jc.caseno,
						description: jc.description,
						team: jc.team,
						handler: jc.handler,
						address: jc.address,
						siteid: jc.siteid,
						site: jc.site,
						opened: jc.opened,
						type: json.panelReferDescription === "Real Estate" ? "SecuredLending" : jc.type,
						casetype: jc.casetype,
						progress: getProgress(jc, json.panelReferDescription === "Real Estate" ? "SecuredLending" : jc.type, state.trackerChartOptions),
						visible: true,
						selected: (jc.caseno === sid),
						wishlisted: jc.wishlisted,
						tracker: updatedTracker,
						stage: getStage(jc.tracker),
						linked: jc.linked,
						unviewActions: unviewActions,
					});
				}
				for (let i = 0; i < state.cases.length; i++) {
					const c = state.cases[i];
					for (let j = 0; j < c.linked.length; j++) {
						const lc = c.linked[j];
						lc.visible = true;
						lc.selected = false;
						lc.progress = getProgress(lc, c.type as keyof TrackerChartOptions, state.trackerChartOptions);
						lc.stage = getStage(lc.tracker);
					}
				}
				state.schemes = [];
				for (let i = 0; i < json.schemes.length; i++) {
					const js = json.schemes[i];
					const ji = js.sites;
					const sites: siteListState[] = [];
					for (var j = 0; j < ji.length; j++) {
						const jt = ji[j];
						sites.push({
							siteid: jt.SiteID,
							site: jt.Site
						});
					}
					state.schemes.push({
						schemeid: js.SchemeID,
						scheme: js.Scheme,
						introducerid: js.IntroducerID,
						introducer: js.Introducer,
						developerid: js.DeveloperID,
						developer: js.Developer,
						sites: sites
					});
				}
				switch (state.sortType.type) {
					case 'Reference':
						state.cases.sort(compareReference);
						break;
					case 'Name':
						state.cases.sort(compareName);
						break;
					case 'Opened':
						state.cases.sort(compareOpened);
						break;
					case 'Type':
						state.cases.sort(compareType);
						break;
					case 'Site':
						state.cases.sort(compareSite);
						break;
					case 'Address':
						state.cases.sort(compareAddress);
						break;
					case 'Wishlist':
						state.cases.sort(compareWishlist);
						break;
					case 'Progress':
						state.cases.sort(compareProgress);
						break;
				}
				if (state.sortType.reverse) {
					state.cases.reverse();
				}
				for (const c of state.cases) {
					if (c.caseno.includes(state.searchStr) ||
						c.description.toLowerCase().includes(state.searchStr.toLowerCase()) ||
						c.address.toLowerCase().includes(state.searchStr.toLowerCase())) {
						c.visible = true;
					} else {
						c.visible = false;
					}
				}
			} catch (e) { }
		})
		builder.addCase(getCase.fulfilled, (state: casesState, action: { payload: string; }) => {
			state.isOpeningCase = false;
			state.isOpeningActions = false;
			state.isOpeningHistory = false;
			state.isOpeningTeam = false;
			state.isOpeningLinkedCase = false;
			state.isOpeningLinkedTeam = false;

			try {
				const json = JSON.parse(action.payload as string);
				if (state.request.caseno !== json.caseno) { return; }

				state.case.historyData = json.historyData.history;
				state.case.details = state.request.details;
				state.case.type = state.request.type;

				state.case.caseno = json.caseno;
				state.case.casetype = json.trackerData.casetype;
				state.case.description = json.trackerDescription;
				state.case.actions = json.actions;
				state.case.IntroducerDates = json.IntroducerDates;

				const c1 = json.homeData.client01;
				const c2 = json.homeData.client02;
				const c3 = json.homeData.client03;
				const c4 = json.homeData.client04;
				const pa = json.propertyAddress;
				if (c1 == null) {
					state.case.client1 = c1;
				} else {
					const c1o = {
						title: c1.ClientTitle,
						firstname: c1.Forename,
						lastname: c1.Surname,
						address1: c1.AddressLine1,
						address2: c1.AddressLine2,
						address3: c1.AddressLine3,
						address4: c1.AddressLine4,
						postcode: c1.Postcode,
						email: c1.EmailMainText,
						mobile: c1.TelMobile
					}
					state.case.client1 = c1o;
				}
				if (c2 == null) {
					state.case.client2 = c2;
				} else {
					const c2o = {
						title: c2.ClientTitle,
						firstname: c2.Forename,
						lastname: c2.Surname,
						address1: c2.AddressLine1,
						address2: c2.AddressLine2,
						address3: c2.AddressLine3,
						address4: c2.AddressLine4,
						postcode: c2.Postcode,
						email: c2.EmailMainText,
						mobile: c2.TelMobile
					}
					state.case.client2 = c2o;
				}
				if (c3 == null) {
					state.case.client3 = c3;
				} else {
					const c3o = {
						title: c3.ClientTitle,
						firstname: c3.Forename,
						lastname: c3.Surname,
						address1: c3.AddressLine1,
						address2: c3.AddressLine2,
						address3: c3.AddressLine3,
						address4: c3.AddressLine4,
						postcode: c3.Postcode,
						email: c3.EmailMainText,
						mobile: c3.TelMobile
					}
					state.case.client3 = c3o;
				}
				if (c4 == null) {
					state.case.client4 = c4;
				} else {
					const c4o = {
						title: c4.ClientTitle,
						firstname: c4.Forename,
						lastname: c4.Surname,
						address1: c4.AddressLine1,
						address2: c4.AddressLine2,
						address3: c4.AddressLine3,
						address4: c4.AddressLine4,
						postcode: c4.Postcode,
						email: c4.EmailMainText,
						mobile: c4.TelMobile
					}
					state.case.client4 = c4o;
				}
				if (pa == null) {
					state.case.property = pa;
				} else {
					const pao = {
						address: pa.address,
						address1: pa.AddressLine1,
						address2: pa.AddressLine2,
						address3: pa.AddressLine3,
						address4: pa.AddressLine4,
						postcode: pa.Postcode
					}
					state.case.property = pao;
				}
			} catch (e) { }
		})
		builder.addCase(getLinkedCase.fulfilled, (state: casesState, action: { payload: string; }) => {
			state.isOpeningCase = false;
			state.isOpeningActions = false;
			state.isOpeningTeam = false;
			state.isOpeningLinkedCase = false;
			state.isOpeningLinkedTeam = false;

			try {
				const json = JSON.parse(action.payload as string);
				if (state.request.caseno !== json.caseno) { return; }

				state.linkedcase.details = state.request.details;
				state.linkedcase.type = state.request.type;

				state.linkedcase.caseno = json.caseno;
				state.linkedcase.casetype = json.trackerData.casetype;
				state.linkedcase.description = json.trackerDescription;
				state.linkedcase.actions = json.actions;
				state.linkedcase.IntroducerDates = json.IntroducerDates;

				const c1 = json.homeData.client01;
				const c2 = json.homeData.client02;
				const c3 = json.homeData.client03;
				const c4 = json.homeData.client04;
				const pa = json.propertyAddress;
				if (c1 == null) {
					state.linkedcase.client1 = c1;
				} else {
					const c1o = {
						title: c1.ClientTitle,
						firstname: c1.Forename,
						lastname: c1.Surname,
						address1: c1.AddressLine1,
						address2: c1.AddressLine2,
						address3: c1.AddressLine3,
						address4: c1.AddressLine4,
						postcode: c1.Postcode,
						email: c1.EmailMainText,
						mobile: c1.TelMobile
					}
					state.linkedcase.client1 = c1o;
				}
				if (c2 == null) {
					state.linkedcase.client2 = c2;
				} else {
					const c2o = {
						title: c2.ClientTitle,
						firstname: c2.Forename,
						lastname: c2.Surname,
						address1: c2.AddressLine1,
						address2: c2.AddressLine2,
						address3: c2.AddressLine3,
						address4: c2.AddressLine4,
						postcode: c2.Postcode,
						email: c2.EmailMainText,
						mobile: c2.TelMobile
					}
					state.linkedcase.client2 = c2o;
				}
				if (c3 == null) {
					state.linkedcase.client3 = c3;
				} else {
					const c3o = {
						title: c3.ClientTitle,
						firstname: c3.Forename,
						lastname: c3.Surname,
						address1: c3.AddressLine1,
						address2: c3.AddressLine2,
						address3: c3.AddressLine3,
						address4: c3.AddressLine4,
						postcode: c3.Postcode,
						email: c3.EmailMainText,
						mobile: c3.TelMobile
					}
					state.linkedcase.client3 = c3o;
				}
				if (c4 == null) {
					state.linkedcase.client4 = c4;
				} else {
					const c4o = {
						title: c4.ClientTitle,
						firstname: c4.Forename,
						lastname: c4.Surname,
						address1: c4.AddressLine1,
						address2: c4.AddressLine2,
						address3: c4.AddressLine3,
						address4: c4.AddressLine4,
						postcode: c4.Postcode,
						email: c4.EmailMainText,
						mobile: c4.TelMobile
					}
					state.linkedcase.client4 = c4o;
				}
				if (pa == null) {
					state.linkedcase.property = pa;
				} else {
					const pao = {
						address: pa.address,
						address1: pa.AddressLine1,
						address2: pa.AddressLine2,
						address3: pa.AddressLine3,
						address4: pa.AddressLine4,
						postcode: pa.Postcode
					}
					state.linkedcase.property = pao;
				}
			} catch (e) { }
		})
		builder.addCase(wishlistCase.fulfilled, (state: casesState, action: { payload: string; }) => {
			state.isWishlisting = false;
			try {
				const json = JSON.parse(action.payload as string);
				const caseno = json.caseno;
				const wishlisted = json.wishlisted;

				for (let c of state.cases) {
					if (c.caseno === caseno) {
						c.wishlisted = wishlisted;
					}
					for (let lc of c.linked) {
						if (lc.caseno === caseno) {
							lc.wishlisted = wishlisted;
						}
					}
				}
				if (state.case.caseno === caseno && state.case.details) {
					state.case.details.wishlisted = wishlisted;
				}
				if (state.linkedcase.caseno === caseno && state.linkedcase.details) {
					state.linkedcase.details.wishlisted = wishlisted;
				}
			} catch (e) { }
		})
		builder.addCase(removeWishlist.fulfilled, (state: casesState, action: { payload: string; }) => {
			state.isWishlisting = false;
			try {
				const json = JSON.parse(action.payload as string);
				const caseno = json.caseno;
				const wishlisted = json.wishlisted;

				for (let c of state.cases) {
					if (c.caseno === caseno) {
						c.wishlisted = wishlisted;
					}
					for (let lc of c.linked) {
						if (lc.caseno === caseno) {
							lc.wishlisted = wishlisted;
						}
					}
				}
				if (state.case.caseno === caseno && state.case.details) {
					state.case.details.wishlisted = wishlisted;
				}
				if (state.linkedcase.caseno === caseno && state.linkedcase.details) {
					state.linkedcase.details.wishlisted = wishlisted;
				}
			} catch (e) { }
		})
		builder.addCase(updateCaseDates.fulfilled, (state: casesState, action: { payload: string; }) => {
			state.isUpdatingDates = false;
			try {
			} catch (e) { }
		})
		builder.addCase(getReportData.fulfilled, (state: casesState, action: { payload: string; }) => {
			state.report.isGenerating = false;
			try {
				const json = JSON.parse(action.payload as string);
				if (state.report.sv !== 'garnet' && state.report.sv !== 'bricklane' && state.report.sv !== 'brickmoor') {
					state.report.sites = json.sites;
				} else {
					state.report.rows = json.rows;
				}
			} catch (e) { }
		})
		builder.addCase(getReportSSRS.fulfilled, (state: casesState, action: { payload: string; }) => {
			state.report.isSaving = false;
			try {
				document.location = 'data:application/vnd.ms-excel;base64,' + action.payload;
			} catch (e) { }
		})
		builder.addCase(getReportXlsx.fulfilled, (state: casesState, action: { payload: string; }) => {
			state.report.isSaving = false;
			try {
				document.location = 'data:application/vnd.ms-excel;base64,' + action.payload;
			} catch (e) { }
		})
		builder.addCase(chaseCase.fulfilled, (state: casesState, action: { payload: string; }) => {
			state.isChasing = false;
			try {
				const json = JSON.parse(action.payload as string);
				if (state.case.caseno === json.caseno) {
					state.case.actions.push(json);
				}
				if (state.linkedcase.caseno === json.caseno) {
					state.linkedcase.actions.push(json);
				}
			} catch (e) { }
		})
		builder.addCase(callCase.fulfilled, (state: casesState, action: { payload: string; }) => {
			state.isCalling = false;
			try {
				const json = JSON.parse(action.payload as string);
				if (state.case.caseno === json.caseno) {
					state.case.actions.push(json);
				}
				if (state.linkedcase.caseno === json.caseno) {
					state.linkedcase.actions.push(json);
				}
			} catch (e) { }
		})
		builder.addCase(pushCase.fulfilled, (state: casesState, action: { payload: string; }) => {
			state.isPushing = false;
			try {
				const json = JSON.parse(action.payload as string);
				if (state.case.caseno === json.caseno) {
					state.case.actions.push(json);
				}
				if (state.linkedcase.caseno === json.caseno) {
					state.linkedcase.actions.push(json);
				}
			} catch (e) { }
		})
		builder.addCase(sendActionResponse.fulfilled, (state: casesState, action: { payload: string; }) => {
			state.isSendingIntroResponse = false;
			try {
				const json = JSON.parse(action.payload as string);

				for (let c of state.case.actions) {
					if (c.id === json.id) {
						c.responded = json.responded;
						c.response = json.response;
						break;
					}
				}
				for (let c of state.linkedcase.actions) {
					if (c.id === json.id) {
						c.responded = json.responded;
						c.response = json.response;
						break;
					}
				}
			} catch (e) { }
		})
	}
})

export const { setUser, setSortType, setSortTypeCCE, setSortTypeWWC, setSortTypeIA, setFilterTeam, setFilterType, setFilterSite, setFilterStatus, setCase, setFilterStage, setFilterWishlist, setCaseNo, setTrackerData, setTrackerChartOptions, searchCases, selectCase, selectLinkedCase, clrCases, clrReport, setLoading, setLoaded, setOpeningCase, setOpeningLinkedCase, setOpeningActions, setOpeningTeam, setOpeningLinkedTeam, setWishlisting, setUpdatingDates, setGenerating, setSaving, setChasing, setCalling, setEmailing, setPushing, setSendingIntroResponse, setReportSV, setSelectedAction, setIframeSsrsSrc, setOpeningHistory, setRowsPerPage, setSkip } = casesSlice.actions;

export default casesSlice.reducer;